import "../../resources/css/anywhere/anywhere-tab.scss"

import React, {Component} from "react";
import classNames from "classnames";
import AvailableGames from "./AvailableGames";
import AvailableGamesScrollMagic from "./AvailableGamesScrollMagic";
import App from "../../containers/App";
import StadiaCard from "./StadiaCard";
import LunaCard from "../../containers/Anywhere/LunaCard";
import FaqList from "./FaqList";
import {AdobeAnalyticsContext} from "../../context/AdobeAnalyticsContext";

const headerImg1 = require("../../resources/img/anywhere/header-img-1.png");
const headerImg2 = require("../../resources/img/anywhere/header-img-2.png");
const devicesIcons = require("../../resources/img/anywhere/devices-icons.svg");
const platformsIcon = require("../../resources/img/anywhere/platforms_icon.svg");
const headerImgAll = require("../../resources/img/anywhere/header-img-all.png");
const rocketIcon = require("../../resources/img/anywhere/rocket-icon.svg");
const friendsIcon = require("../../resources/img/anywhere/friends-icon.svg");
const closeButton = require("../../resources/img/anywhere/close-btn.svg");

interface Props {
    showAllGames: boolean;
    onShowAllGames: () => void;
    onHideAllGames: () => void;
}

export class Anywhere extends Component<Props> {
    static contextType = AdobeAnalyticsContext;
    context!: React.ContextType<typeof AdobeAnalyticsContext>;

    render(): JSX.Element {
        return (
            <div
                className={
                    classNames({
                        container__anywhereTab: true,
                        modal__open: this.props.showAllGames
                    })
                }
            >
                <header className="anywhereTab__header">
                    <div className="anywhereTab__header__container">

                        <div className="img">
                            <img src={headerImg1} alt="Game on Laptop"/>
                        </div>

                        <div className="anywhereTab__header__content">
                            <img src={devicesIcons} alt="Gaming Devices"/>
                            <img src={headerImgAll} alt="Gaming on All Devices"/>

                            <h1>Discover Ubisoft's worlds <span>with <span>cloud gaming (beta)</span></span></h1>
                            <h2>
                                Expand your way of playing with beta access to Ubisoft+ on the Amazon Luna and Google Stadia (coming soon) cloud gaming platforms.<br />
                                Play select Ubisoft games on multiple compatible devices. Now included in your subscription for a limited time at no additional cost!
                            </h2>
                        </div>

                        <div className="img">
                            <img src={headerImg2} alt="Game on Mobile"/>
                        </div>

                    </div>
                </header>

                <section className="anywhereTab__cards">

                    <h3 className="section-title">Enjoy beta access to Ubisoft+ on Stadia and Luna</h3>

                    <div className="anywhereTab__cards__container">

                        <StadiaCard />
                        <LunaCard analyticsContext={this.context}/>

                    </div>
                </section>

                <section className="anywhereTab__features">

                    <h3 className="section-title">Features you can enjoy</h3>

                    <div className="anywhereTab__features__container">

                        <div className="anywhereTab__features__feature">
                            <img src={platformsIcon} alt="Cross-platform"/>
                            <h4>Cross-progression</h4>
                            <p>Pick up where you left off from your mobile device to your laptop, and keep your gear, characters and progress&#42;.</p>
                            <span className="footnote">
                                &#42;Cross-progression and cross-play functions are in beta, may vary between the platforms and game progress may be lost.
                                For more details, see the <a href="https://support.ubisoft.com/faqs/000059698" target="_blank" rel="noopener noreferrer">dedicated FAQ article</a>.
                            </span>
                        </div>

                        <div className="anywhereTab__features__feature">
                            <img src={rocketIcon} alt="Rocket"/>
                            <h4>Go beyond your PC</h4>
                            <p>Play instantly in more places, all you need is a high-speed connection! Jump back in your game whether you're at a coffee shop, visiting family, or even waiting for your favorite take-out.</p>
                        </div>

                        <div className="anywhereTab__features__feature">
                            <img src={friendsIcon} alt="Friends"/>
                            <h4>Cross-play</h4>
                            <p>Play select upcoming titles with your friends whether they are playing on their PC, on Stadia or on Luna. Enjoy games together from the device you want&#42;!</p>
                        </div>

                    </div>
                </section>

                {App.isMobile.any && <AvailableGames onShowAllGames={this.props.onShowAllGames} />}
                {!App.isMobile.any && <AvailableGamesScrollMagic onShowAllGames={this.props.onShowAllGames} />}

                <FaqList />

                <div className="anywhereTab__modal">
                    <div className="anywhereTab__modal__container">
                        <nav className="anywhereTab__modal__nav">
                            <button className="tab disabled">Stadia <span>(coming soon)</span></button>
                            <button className="tab">Luna</button>
                            <button onClick={this.props.onHideAllGames}>
                                <img src={closeButton} alt="Close" aria-labelledby="Close" />
                            </button>
                        </nav>

                        <div className="anywhereTab__modal__content">

                            <p>Games currently available. More coming soon!</p>

                            <div className="game-list">
                                <ul>
                                    <li>Assassin’s Creed Odyssey</li>
                                    <li>Assassin’s Creed Origins</li>
                                    <li>Assassin’s Creed Syndicate</li>
                                    <li>Assassin’s Creed Valhalla</li>
                                    <li>Far Cry Primal</li>
                                    <li>Far Cry 5</li>
                                    <li>Far Cry New Dawn</li>
                                    <li>Monopoly Plus</li>
                                </ul>
                                <ul>
                                    <li>Steep X Games</li>
                                    <li>Ghost Recon Breakpoint</li>
                                    <li>Ghost Recon Wildlands</li>
                                    <li>Tom Clancy’s The Division</li>
                                    <li>Trials Fusion</li>
                                    <li>Watch_Dogs</li>
                                    <li>Watch Dogs: Legion (coming soon)</li>
                                </ul>
                            </div>

                            <button className="btn btn__ghost" onClick={this.props.onHideAllGames}>Close</button>
                        </div>
                    </div>
                    <div className="overlay" onClick={this.props.onHideAllGames}/>
                </div>
            </div>
        );
    }
}